import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import MonoHtmlView from './CommissionHtml';
import MonoReactView from './Commission';
const CommissionMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(MonoHtmlView, _extends({}, props));
    }
    return /*#__PURE__*/ React.createElement(MonoReactView, _extends({}, props));
};
CommissionMonoView.displayName = 'CommissionMonoView';
export default CommissionMonoView;
